import React from 'react';

import Header from '../../layout/Header.jsx';
import ListScores from '../../lists/ListScores.jsx';

const PageScores = () => (
  <div>
    <Header>Performance</Header>
    <ListScores />
  </div>
);

export default PageScores;
